<section class="w-full bg-primary pt-10 sm:pt-16 pb-12 sm:pb-20">
  <div class="container mx-auto">
    <div *ngFor="let slotable of contentModule.slotables" class="w-full sm:px-2/24">
      <app-slot-a044 [slotable]="slotable"></app-slot-a044>
    </div>
  </div>
</section>
